const CargoIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.16667 17.3083V9.68335L0.5 5.82918V12.5167C0.5 12.8222 0.572917 13.1 0.71875 13.35C0.864583 13.6 1.06944 13.8014 1.33333 13.9542L7.16667 17.3083ZM8.83333 17.3083L14.6667 13.9542C14.9306 13.8014 15.1354 13.6 15.2812 13.35C15.4271 13.1 15.5 12.8222 15.5 12.5167V5.82918L8.83333 9.68335V17.3083ZM12.1458 5.85002L14.6042 4.41252L8.83333 1.10002C8.56944 0.947238 8.29167 0.87085 8 0.87085C7.70833 0.87085 7.43056 0.947238 7.16667 1.10002L5.52083 2.03752L12.1458 5.85002ZM8 8.24585L10.4792 6.82918L3.875 2.99585L1.375 4.43335L8 8.24585Z"
      fill="currentColor"
    />
  </svg>
);

export default CargoIcon;
